import type { TRuleWithTheme } from '@/styles/theme';

export const info: TRuleWithTheme = () => ({
    marginTop: '0.25rem',
    marginBottom: '1.5rem',
});
